import React, { Component } from "react";
import { connect } from "react-redux";
import { ForgetPasswordService } from "app/_services/ForgetPassword/ForgetPasswordService";
import toastr from "toastr";
import { Validation } from "app/_helpers/validation/Validation";
import "./signin.css";
import MobileFooter from "./MobileFooter";


class ForgotPassword extends Component {
  state = {
    email: "",
    error: {},
    submitted: false,
  };





  setEmail = (e) => {
    this.setState(
      {
        email: e.target.value,
      },
      () => {
        this.checkValidation();
      }
    );
  };

  onSubmit = async (e) => {
    e.preventDefault();
    let data = {
      email: this.state.email,
    };
    let errobj = {};
    errobj = Validation(this.state, [
      {
        field_name: "email",
        label: "Email",
        type: "email",
        isRequired: true,
      },
    ]);
    this.setState({ error: errobj, submitted: true });
    if (Object.keys(this.state.error).length === 0 || this.state.error.email === "") {
      let response = await ForgetPasswordService.ForgetPassword(data);
      if (response && response.status === 1) {
        toastr.success("Please Check Reset Password Link on Your Registered Email","",{
          positionClass:"successToasterMsg toast-bottom-full-width",
        });
        this.props.history.push("/mobile/auth/sign-in");
      } else {
        toastr.warning(response.message);
      }
    }
  };

  checkValidation = () => {
    if (this.state.submitted) {
      var errobj = {};
      errobj = Validation(this.state, [
        {
          field_name: "email",
          label: "Email",
          type: "email",
          isRequired: true,
        },
      ]);
      this.setState({ error: errobj, submitted: true });
    }
  };
  render() {
    return (
      <React.Fragment>
        <div class="loginWrapper">
          <div className="loginFormSec">
            <div className="loginScreenHeader">
              <img src="/img/net-zero-logo.svg" alt="net-zero-logo" />
            </div>
            <div className="loginScreenFormSec">
              <div class="formSigninNew">
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    className={`form-control email-icon ${this.state?.error?.email ? "error" : ""}`}
                    type="text"
                    name="email"
                    placeholder=""
                    value={this.state.email}
                    onChange={(e) => { this.setEmail(e) }}
                  />

                  {this.state.submitted &&
                    this.state.error &&
                    this.state.error.email !== "" && (
                      <div className="fromerror">{this.state.error.email}</div>
                    )}
                </div>
                <button onClick={(e) => this.onSubmit(e)} className="btn primary-btn" type="submit">
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
        <MobileFooter />
      </React.Fragment>

    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, {
})(ForgotPassword);
